import React from 'react';
import { WsDrawer, WsDrawerProps } from 'wisestep-base';

type ProviderContext = readonly [(option: DrawerOption) => void, () => void];

const EMPTY_FUNC = () => {};
const DrawerContext = React.createContext<ProviderContext>([EMPTY_FUNC, EMPTY_FUNC]);
export const useDrawer = () => React.useContext(DrawerContext);

type DrawerParams = {
  children: React.ReactNode;
  open: boolean;
  size?: 'small' | 'medium' | 'large';
  title?: string;
  props?: Omit<WsDrawerProps, 'open' | 'onClose' | 'children' | 'size'>;
  onClose?: () => void;
  onExited?: () => void;
};
type DrawerOption = Omit<DrawerParams, 'open'>;

const DrawerProvider = ({ children }) => {
  const [drawer, setDrawer] = React.useState<DrawerParams | null>(null);
  const createDrawer = (option: DrawerOption) => {
    setDrawer({ ...option, open: true });
  };
  const closeDrawer = () => {
    setDrawer({ ...drawer, children: drawer?.children, open: false });
  };
  const contextValue = React.useRef([createDrawer, closeDrawer] as const);

  return (
    <DrawerContext.Provider value={contextValue.current}>
      {children}
      {drawer && (
        <WsDrawer
          open={drawer.open}
          onClose={() => setDrawer({ ...drawer, open: false })}
          size={drawer.size || 'medium'}
          {...drawer.props}
          title={drawer.title}
          headerSize="medium"
        >
          {drawer.children}
        </WsDrawer>
      )}
    </DrawerContext.Provider>
  );
};

export default DrawerProvider;
